<template>
  <div class="exhibitsListBox">
    <div class="head max-width">
      <!-- 头部banner-->
      <div class="head-img">
        <img :src="headImgUrl" />
      </div>
      <!-- 导航栏-->
      <div class="head-nav">
        <div class="sub-nav" v-for="(item,index) in navList" :key="index" @click="goLink(item.link)">{{item.title}}</div>
      </div>
    </div>

    <!-- 展厅背景图-->
    <div class="bg">
      <div class="bg-center">
        <h3>线上展厅</h3>
      </div>
      <div class="bg-btm"></div>
    </div>

    <!-- 地图指引-->
    <div class="map-menu max-width">
      <div class="map-menu-box">
        <div class="map-menu-left">
          <div class="map-icon">
            <img src="../../static/image/map-icon.png"/>
          </div>
          <div class="map-info">
            您在这里：
            <span class="map-nav">{{mapInfo.nav}}</span>
            <span class="map-line">/</span>
            <span class="map-title">{{mapInfo.title}}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="content max-width">
      <!-- 搜索-->
      <div class="cate-search">
        <div class="cate-search-title">所有分类</div>
        <div class="cate-search-input">
          <div class="search-input">
            <input type="text" v-model="keywords" placeholder="请输入产品/品牌名称" />
          </div>
          <div class="search-icon" @click="search()">
            <img src="../../static/image/search-icon.png" />
          </div>
        </div>
      </div>

      <div class="content-box">
        <div class="content-left">
          <ul class="content-left-ul cate-list">
            <li class="back-home" @click="toUrl('/home')">返回上一级</li>
            <li class="exhibitsList-sub-cate" v-for="(item,index) in cateList" :key="index" @click="getCate(item.id)">{{item.name}}</li>
          </ul>
        </div>
        <div class="content-right">
          <div class="content-right-top">
            <div class="top-title" @click="toUrl('/exhibitorsList')">参展商</div>
            <div class="top-title top-title-active" @click="toUrl('/exhibits')">参展产品</div>
          </div>
          <div class="exhibits-list">
            <div class="sub-list" v-for="(item,index) in exhibitsList" :key="index">
              <div class="exhibitsList-pro-cover" @click="goPro('exhibitsDetail',item.goods_id)">
                <img :src="item.images" />
              </div>
              <div class="pro-name" @click="goPro('exhibitsDetail',item.goods_id)">{{item.goods_name}}</div>
              <div class="exhibitors-name">展商：{{item.exhibitors_name}}</div>
              <div class="exhibitors-cate">展区：{{item.category_pid_name}}</div>
              <div class="exhibitors-code">展位：{{item.category_name}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部-->
    <div class="footer">
      <div class="footer-box max-width">
        <div class="footer-left">
          <div class="footer-company">{{footer.companyInfo.name}}</div>
          <div class="footer-tip">{{footer.companyInfo.tip}}</div>
        </div>
        <div class="footer-center">
          <img :src="footer.codeUrl" />
        </div>
        <div class="footer-right">
          <div class="footer-phone">
            <span class="footer-title">{{footer.phone}}</span>
            <img class="footer-icon" src="../../static/image/footer-phone-icon.png" />
          </div>
          <div class="footer-mobile">
            <span class="footer-title">{{footer.mobile}}</span>
            <img class="footer-icon" src="../../static/image/footer-mobile-icon.png" />
          </div>
          <div class="footer-email">
            <span class="footer-title">{{footer.email}}</span>
            <img class="footer-icon" src="../../static/image/footer-email-icon.png" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'exhibits',
    data () {
      return {
        keywords: '',
        headImgUrl: 'https://www.ywwjz.com/assets/img/head_logo.png',
        navList: [{
          'title': '首页',
          'link': 'https://www.ywwjz.com'
        }, {
          'title': '展会信息',
          'link': 'https://www.ywwjz.com/p/aboutus'
        }, {
          'title': '线上展厅',
          'link': 'https://www.ywwjz.com/wszt.html#/home'
        }, {
          'title': '展会新闻',
          'link': 'https://www.ywwjz.com/c/zhxw.html'
        }, {
          'title': '联系我们',
          'link': 'https://www.ywwjz.com/d/message.html'
        }],
        mapInfo: {
          nav: '首页',
          title: '网上展厅',
          msg: '温馨提示：以下展品展示，仅供参考'
        },
        cateList: [],
        exhibitsList: [],
        footer: {
          companyInfo: {
            name: '中国义乌文具礼品展览会',
            tip: 'CHINA YIWU STATIONERY&GIFT EXHIBITION'
          },
          codeUrl: 'https://www.ywwjz.com/uploads/20200512/4dce8c3bbb75345f7dea9c5ba5c81f60.png',
          phone: '0579—85163311',
          mobile: '18867567324',
          email: '964959387@qq.com'
        }
      }
    },
    mounted () {
      if(this.$route.query.title){
        this.keywords = this.$route.query.title;
      }
      this.init();
    },
    methods: {
      init(){
        const that = this;
        var api = 'https://www.ywwjz.com/addons/litestore/api.index/get_goods';
        that.$http.get(api, {params: {title: that.keywords}}).then((res) => {
            // 响应成功回调
            if(res.body.code == 1){
              that.cateList = res.body.data.category_list;
              that.exhibitsList = res.body.data.goods;
            }else{
              console.log('获取数据失败')
            }
        }, (error) => {
            // 响应错误回调
            console.log(error);
        });
      },
      //展区分类
      getCate(id){
        const that = this;
        var api = 'https://www.ywwjz.com/addons/litestore/api.index/get_goods';
        that.$http.get(api, {params: {category_pid_id: id}}).then((res) => {
            // 响应成功回调
            if(res.body.code == 1){
              that.exhibitsList = res.body.data.goods;
            }else{
              console.log('获取数据失败')
            }
        }, (error) => {
            // 响应错误回调
            console.log(error);
        });
      },
      //路由跳转
      toUrl(url){
        this.$router.push({ path: url })
      },
      goPro(url,id){
        this.$router.push({name: url, query: { id: id }});
      },
      //跳转地址
      goLink(url){
        window.location.href=url
      },
      search(){
        const that = this;
        var api = 'https://www.ywwjz.com/addons/litestore/api.index/search';
        that.$http.get(api, {params: {type: 3, title: this.keywords}}).then((res) => {
            // 响应成功回调
            if(res.body.code == 1){
              that.exhibitsList = res.body.data.goods;
            }else{
              console.log('获取数据失败')
            }
        }, (error) => {
            // 响应错误回调
            console.log(error);
        });
      },
    }
  }
</script>

<style>
  body {
    margin: 0;
    font-family: arial, 'Microsoft YaHei', helvetica, sans-serif;
  }
  .max-width {
    max-width: 1200px;
    margin: 0 auto;
  }
  .head-img img {
    width: 100%;
    display: block;
  }
  .head-nav {
    overflow: hidden;
    height: 50px;
    line-height: 50px;
    text-align: center;
    background: #046575;
    color: #FFFFFF;
    font-size: 16px;
    font-weight: bolder;
    letter-spacing: 5px;
  }
  .sub-nav {
    width: 20%;
    float: left;
    color: white;
    font-weight: bold;
    font-size: 18px;
    letter-spacing: 0px;
  }
  .sub-nav:hover {
    background: #13b5b1;
    cursor: pointer;
  }
  .bg {
    background: url(https://www.ciie.org/resource/static/zbh/default/assets-2019/img/innerbannerbg.png) center;
    background-size: cover;
    min-height: 240px;
    overflow: hidden;
    position: relative;
    width: 100%;
  }
  .bg-center {
    max-width: 1200px;
    margin: 0 auto;
    text-align: center;
    color: #FFFFFF;
    font-size: 30px;
    font-weight: bolder;
  }
  .bg-center h3 {
    margin-top: 80px;
  }
  .bg-btm {
    background: url(https://www.ciie.org/resource/static/zbh/default/assets-2019/img/svg326.png) 0 top;
    background-size: 100%;
    position: absolute;
    width: 100%;
    bottom: 0;
    z-index: 0;
    height: 48px;
  }
  .map-menu {
    height: 60px;
    line-height: 60px;
    padding: 0 15px;
    color: #666666;
  }
  .map-menu-box {
    overflow: hidden;
    border-bottom: 2px solid rgba(0, 0, 0, 0.07);
  }
  .map-menu-left {
    float: left;
    overflow: hidden;
  }
  .map-icon {
    float: left;
    width: 20px;
    height: 20px;
    position: relative;
    top: 20px;
    margin-right: 20px;
  }
  .map-icon img {
    width: 100%;
    height: 100%;
    display: block;
  }
  .map-info {
    float: left;
  }
  .map-nav {
    color: #66aeff;
    cursor: pointer;
  }
  .map-line {
    margin: 0 5px;
    color: #cccccc;
  }
  .map-menu-right {
    float: right;
    color: #ff5503;
  }
  .content {
    padding-top: 30px;
    min-height: 600px;
  }
  .cate-search {
    overflow: hidden;
    background: #046575;
    height: 36px;
    line-height: 36px;
    padding: 10px 0;
  }
  .cate-search-title {
    width: 16%;
    float: left;
    color: #FFFFFF;
    cursor: pointer;
    text-align: center;
    font-size: 20px;
    font-weight: 700;
  }
  .cate-search-select {
    width: 16%;
    float: left;
    cursor: pointer;
  }
  .search-select {
    width: 100%;
    height: 36px;
    border: none;
    border-radius: 10px;
    padding: 0 10px;
    color: #666666;
    cursor: pointer;
  }
  .cate-search-input {
    width: calc(30% - 15px);
    padding-right: 15px;
    float: right;
    overflow: hidden;
  }
  .search-input {
    width: calc(100% - 36px);
    float: left;
  }
  .search-input input {
    width: 100%;
    height: 36px;
    line-height: 36px;
    border: none;
    padding: 0 0 0 10px;
    margin: 0;
    display: block;
  }
  .search-icon {
    float: left;
    width: 16px;
    height: 16px;
    background: #d9dee2;
    padding: 10px;
    cursor: pointer;
  }
  .search-icon:hover {
    background: #FFC107;
  }
  .search-icon img {
    width: 100%;
    height: 100%;
    display: block;
  }
  .content-box {
    overflow: hidden;
    margin-top: 30px;
  }
  .content-left {
    width: calc(30% - 25px);
    padding-right: 25px;
    float: left;
  }
  .content-left-ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
  }
  .exhibitsList-sub-cate {
    height: 66px;
    line-height: 66px;
    background: #f3f3f3;
    color: #5e6f83;
    border-top-right-radius: 6px;
    border-bottom-right-radius: 6px;
    margin-bottom: 5px;
    font-size: 15px;
    font-weight: bold;
    position: relative;
    padding: 0 30px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: pointer;
  }
  .exhibitsList-sub-cate:hover {
    background: #0067cb;
    color: #FFFFFF;
    border-left: 3px solid #046575;
  }
  .exhibitsList-sub-cate::after {
    content: '';
    width: 10px;
    height: 10px;
    border-top: 2px solid #bbbbbb;
    border-right: 2px solid #bbbbbb;
    transform: rotate(45deg);
    position: absolute;
    top: 50%;
    right: 20px;
    margin-top: -5px;
  }
  .exhibitsList-sub-cate:hover::after {
    border-top: 2px solid #FFFFFF;
    border-right: 2px solid #FFFFFF;
  }
  .back-home {
    height: 52px;
    line-height: 52px;
    background: #046575;
    color: #FFFFFF;
    font-size: 18px;
    text-align: center;
    position: relative;
    cursor: pointer;
  }
  .back-home::before {
    content: '';
    width: 10px;
    height: 10px;
    border-top: 4px solid #FFFFFF;
    border-right: 4px solid #FFFFFF;
    transform: rotate(-135deg);
    position: absolute;
    top: 50%;
    left: 20px;
    margin-top: -5px;
  }
  .content-right {
    width: 70%;
    float: right;
  }
  .content-right-top {
    overflow: hidden;
    font-size: 14px;
    font-weight: bold;
    background: #EFEFEF;
    padding: 6px 0;
  }
  .top-title {
    width: 100px;
    float: left;
    padding: 0 15px;
    text-align: center;
    cursor: pointer;
  }
  .top-title:first-child {
    border-right: 1px solid #CCCCCC;
  }
  .top-title:last-child {
    border-left: 1px solid #CCCCCC;
  }
  .top-title-active {
    color: #d01d1b;
  }
  .top-title:hover {
    color: #32bfc0;
  }
  .top-title-active:hover {
    color: #d01d1b;
  }
  .exhibits-list {
    margin-top: 30px;
    overflow: hidden;
  }
  .sub-list {
    width: calc((100% - 60px) / 3);
    padding: 0 10px;
    float: left;
    margin-bottom: 30px;
  }
  .exhibitsList-pro-cover {
    height: 200px;
    overflow: hidden;
    cursor: pointer;
    border: 1px solid #dddddd;
  }
  .exhibitsList-pro-cover img {
    width: 100%;
    max-height: inherit;
  }
  .pro-name {
    padding: 0 10px;
    margin: 10px 0;
    width: calc(100% - 20px);
    height: 40px;
    font-size: 14px;
    font-weight: bold;
    color: #000000;
    line-height: 20px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    white-space: normal;
    overflow: hidden;
    cursor: pointer;
  }
  .pro-name:hover {
    color: #046575;
  }
  .exhibitors-name,.exhibitors-cate,.exhibitors-code {
    font-size: 14px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    line-height: 1.8;
    color: #666e70;
  }
  .footer {
    margin-top: 50px;
    background: rgba(73,73,73,1);
    color: #FFFFFF;
  }
  .footer-box {
    overflow: hidden;
    padding: 30px 0;
  }
  .footer-left {
    float: left;
    width: 30%;
    height: 100px;
  }
  .footer-company {
    font-size: 30px;
    margin: 20px 0 5px 0;
    font-weight: bold;
  }
  .footer-tip {
    font-size: 15px;
  }
  .footer-center {
    float: left;
    width: 40%;
    height: 100px;
  }
  .footer-center img {
    width: 100px;
    height: 100px;
    display: block;
    margin: 0 auto;
  }
  .footer-right {
    float: right;
    width: 30%;
    height: 100px;
    text-align: right;
    font-size: 15px;
  }
  .footer-phone {
    overflow: hidden;
    margin-top: 5px;
  }
  .footer-mobile {
    overflow: hidden;
  }
  .footer-email {
    overflow: hidden;
  }
  .footer-icon {
    width: 30px;
    height: 30px;
    float: right;
  }
  .footer-title {
    float: right;
    height: 30px;
    line-height: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/exhibits.vue